var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTurFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h60v45H0V0Z",
    fill: "#E30A17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.156 23.203c0 6.206-5.118 11.24-11.437 11.24-6.319 0-11.438-5.034-11.438-11.25 0-6.215 5.119-11.23 11.438-11.23 6.319 0 11.437 5.034 11.437 11.24Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.719 23.203c0 4.969-4.088 8.99-9.14 8.99-5.054 0-9.15-4.03-9.15-9 0-4.968 4.096-8.98 9.15-8.98 5.052 0 9.15 4.021 9.15 8.99h-.01Z",
    fill: "#E30A17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40.378 17.953-.093 4.153-3.872 1.05 3.825 1.36-.094 3.815 2.484-2.98 3.769 1.312-2.175-3.197 2.653-3.178-4.078 1.125-2.419-3.47v.01Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h60v45H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTurFlag);
export default __webpack_public_path__ + "static/media/tur-flag.58424e9d52de27fa42b18d534d9cf991.svg";
export { ForwardRef as ReactComponent };